import { type TranslationIDs, useIntl } from '@capsicum/common';
import { Tooltip } from '@capsicum/common-web';
import { InfoIcon } from '@capsicum/common-web/icons';
import styled, { useTheme } from 'styled-components';

type WalletCollectiblesTooltipProps = {
	onTriggerClick?: () => void;
};

export const WalletCollectiblesTooltip = ({ onTriggerClick }: WalletCollectiblesTooltipProps) => {
	const { $t } = useIntl();
	const theme = useTheme();

	const digitalCollectiblesTooltipText = {
		description: $t('wallet.digitalCollectibles.tooltip.description' as TranslationIDs),
		title: $t('wallet.digitalCollectibles.tooltip.title' as TranslationIDs)
	};

	return (
		<Tooltip>
			<Tooltip.Trigger testID="wallet-digitalCollectibles-tooltip">
				<S.InfoIconStyled
					color={theme.colors.icons.info.enabled}
					height="16"
					width="16"
					onClick={onTriggerClick}
				/>
			</Tooltip.Trigger>
			<Tooltip.Content>
				<Tooltip.Title>
					<S.TooltipTitleText>{digitalCollectiblesTooltipText.title}</S.TooltipTitleText>
				</Tooltip.Title>
				<Tooltip.Description>
					<div>{digitalCollectiblesTooltipText.description}</div>
				</Tooltip.Description>
			</Tooltip.Content>
		</Tooltip>
	);
};

namespace S {
	export const InfoIconStyled = styled(InfoIcon)`
		flex-shrink: 0;
	`;
	export const TooltipTitleText = styled.div`
		${({ theme }) => theme.fonts.headings.title6};
		margin-bottom: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
